import { takeEvery, put, select, take, call } from 'redux-saga/effects';
import { browserHistory } from 'react-router';

import * as login from './login';
import * as loginAzure from './login-azure';
import * as editUser from '../profiles/edit-user';
import { consts as signup } from './signup/signup-req';
import { consts as filters } from '../board/filters';
import { consts as savedSurveys } from '../surveys/saved';
import {
  isLoggedInSelector,
  selectLoggedUserId,
  selectRegistrationCompleted,
  selectRequestPasswordUpdate,
} from './selectors';
import {
  CHANGE_PASSWORD,
  COMMUNITIES,
  HEALTHBOARD,
} from '../../constants/routes';
import {
  ACTIVE_COMMUNITY_ID,
  REQUEST_PASSWORD_UPDATE,
  REDIRECT_TO_PAGE,
} from '../../constants/storageKeys';
import * as profileEditable from '../profiles/profile-editable-req';
import { CustomEvents, GATrackCustomEvent } from '../../gtag';
import { selectAuthStatusInvitationType } from './signup/selectors';

function replaceIdInHealthBoardRoute(route, id) {
  if (route.startsWith(`${HEALTHBOARD}`)) {
    const regex = new RegExp(`^${HEALTHBOARD}/(\\d+)(/.*)?$`);

    return route.replace(regex, `${HEALTHBOARD}/${id}$2`);
  }

  return route;
}

export function redirect(loggedUserId) {
  const communityId = window.storage.getItem(ACTIVE_COMMUNITY_ID);
  const redirectToPage = window.storage.getItem(REDIRECT_TO_PAGE);

  if (redirectToPage) {
    const redirectRoute = replaceIdInHealthBoardRoute(
      redirectToPage,
      loggedUserId,
    );

    browserHistory.push(redirectRoute);
    window.storage.removeItem(REDIRECT_TO_PAGE);

    return;
  }

  const redirectUrl = communityId
    ? `/${COMMUNITIES}/${communityId}`
    : `/${HEALTHBOARD}`;

  browserHistory.push(redirectUrl);
}

function* authSagaWorker() {
  const loggedUserId = yield select(selectLoggedUserId);
  const inviteType = yield select(selectAuthStatusInvitationType);
  const isRequestPasswordUpdate = yield select(selectRequestPasswordUpdate);
  const isRegistrationCompleted = yield select(selectRegistrationCompleted);

  if (isRequestPasswordUpdate || (!isRegistrationCompleted && !inviteType)) {
    yield put(profileEditable.actions.send({ userId: loggedUserId }));

    browserHistory.push(CHANGE_PASSWORD);
    yield take(editUser.consts.SUCCEED);

    window.storage.setItem(REQUEST_PASSWORD_UPDATE, 'false');
    yield put(login.actions.updatePassword());
  }
  const isLoggedIn = yield select(isLoggedInSelector);
  yield put({ type: filters.RESTORE });
  yield put({ type: savedSurveys.RESTORE });
  if (isLoggedIn) {
    yield call(() => GATrackCustomEvent(CustomEvents.SUCCESS_LOGIN));
    redirect(loggedUserId);
  }
}

export default function* authSaga() {
  yield takeEvery(
    [login.consts.SUCCEED, signup.SUCCEED, loginAzure.consts.SUCCEED],
    authSagaWorker,
  );
}



// WEBPACK FOOTER //
// ./src/redux/auth/authSaga.js